import { Resource } from 'constants/resources';

import { SxProps, Theme } from '@mui/material';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { RaRecord } from 'react-admin';
import { Link } from 'react-router-dom';
import { Box } from 'shared/mui/Box';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';

import { StyledTypography } from './TextLinkField.styled';

export type TextLinkFieldProps = {
  source: string;
  value?: string;
  resource: Resource;
  type: string;
  sx?: SxProps<Theme>;
} & Omit<FunctionFieldProps, 'render'>;

export const TextLinkField: React.FC<TextLinkFieldProps> = ({
  source,
  sx,
  resource,
  type,
  value,
  ...rest
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <FunctionField
      render={(record: RaRecord) => {
        return (
          <Box>
            <Link to={createPathWithQuery({ resource, id: record.id, type })}>
              <StyledTypography sx={sx}>{value || record[source]}</StyledTypography>
            </Link>
          </Box>
        );
      }}
      {...rest}
    />
  );
};
